import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import CategorySecondaryOptionAddEdit from "./CategorySecondaryOptionAddEdit";

import CategorySecondaryOptionTable from "./CategorySecondaryOptionTable";

function CategorySecondaryOptionContainer() {
  const { path } = useRouteMatch();
  return (
    <>
      <Switch>
        <Route exact path={`${path}/edit/:id`}>
          <CategorySecondaryOptionAddEdit />
        </Route>
        <Route exact path={`${path}/add`}>
          <CategorySecondaryOptionAddEdit />
        </Route>
        <Route path={`${path}`}>
          <CategorySecondaryOptionTable />
        </Route>
      </Switch>
    </>
  );
}

export default CategorySecondaryOptionContainer;
